import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputTelefonatAnhang<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: filename */
  filename?: string;
  /** Alias: notiz */
  notiz?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputTelefonatAnhang> = {
  code: {
    alias: 'code',
  },
  filename: {
    alias: 'filename',
  },
  notiz: {
    alias: 'notiz',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputTelefonatAnhangEntityDefinition: EntitiyDefinition<InputTelefonatAnhang> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputTelefonatAnhang',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
